import React from 'react';
import './index.css';

const ServicesPage = () => {
    return (
        <div className="services-container">
            <div className="image-sectionvilla"></div>
            <div className="content-section">
                <h2>
                    AVAILABLE SERVICES
                </h2>
                <p className="note">* All additional services at the villa are charged separately.</p>
                <ul>
                <li>Private chef available to prepare customized meals</li>
                <li>24/7 security personnel on-site for guest safety</li>
                <li>CCTV surveillance around the property for added security</li>
                <li>Cab services for local sightseeing and airport transfers</li>
                <li>Daily housekeeping and linen change services</li>
                <li>Laundry services with 24-hour turnaround</li>
                <li>High-speed Wi-Fi and workspace setup on request</li>
                <li>Grocery pre-stocking and daily provisioning on demand</li>
                <li>Assistance with planning celebrations or special occasions</li>
                </ul>
            </div>
        </div>
    );
};

export default ServicesPage;